import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import useStyles from './ActionBarInput.styles';
export const ActionBarInput = ({ className, icon, label, value, type, disabled, maxWidth, autoFocus, onClick, onChange, onBlur, }) => {
    const classes = useStyles();
    return (_jsxs("div", Object.assign({ className: cn(classes.root, className), style: { maxWidth } }, { children: [_jsx("input", { className: cn(classes.input, icon && classes.inputWithIcon), placeholder: label, value: value, type: type, disabled: disabled, onClick: onClick, onChange: (event) => {
                    if (onChange) {
                        onChange(event.target.value);
                    }
                }, onBlur: onBlur, autoFocus: autoFocus }), icon && _jsx("div", Object.assign({ className: classes.icon }, { children: icon }))] })));
};
export default ActionBarInput;
//# sourceMappingURL=ActionBarInput.js.map